import Skeleton from "react-loading-skeleton";

import type { BaseItem, GroupedItem } from "@/core/types";
import { Select2 } from "@/ui2/molecules/Select";
import type { SelectProps } from "@/ui2/molecules/Select";

import { useReasoningOptions } from "../api/queries/useReasoningOptions";

import "react-loading-skeleton/dist/skeleton.css";

type ReasoningSelectProps<T extends GroupedItem<BaseItem>> = Omit<
  SelectProps<T>,
  "label" | "mode" | "name" | "options"
>;

export function ReasoningSelect<T extends GroupedItem<BaseItem>>(props: ReasoningSelectProps<T>) {
  const { data: reasoningOptions, isLoading } = useReasoningOptions();

  if (isLoading) return <Skeleton className="tw:mt-5.5 tw:w-full" height={SKELETON_HEIGHT} />;

  return (
    <Select2
      label="Reasoning"
      mode="grouped"
      name="reasoning"
      options={reasoningOptions ?? []}
      {...props}
    />
  );
}

const SKELETON_HEIGHT = 44;
